import { useNavigate } from "react-router";

import { Badge, BadgeColor, Button, ButtonStyle, TableRow } from "@prequel/shared-components";

import { useProducts } from "@/api/queries/products";
import ResourceTable from "@/components/ResourceTable";
import Timestamp from "@/components/Timestamp";
import { ExistingProduct } from "@/types";

const PRODUCT_TABLE_COLUMNS = ["Product Name", "Models", "Description", "Created At"];

const mapProductToRow = (product: ExistingProduct): TableRow => ({
  id: product.id,
  to: `/models/products/${product.id}`,
  cells: [
    { value: product.product_name },
    {
      value: (
        <>
          {product.models.length
            ? product.models.map((model: string) => (
                <Badge key={model} className="mr-1" text={model} color={BadgeColor.GRAY} />
              ))
            : "No models defined"}
        </>
      ),
    },
    { value: product.description },
    { value: <Timestamp timestamp={product.created_at} /> },
  ],
});

const ProductsTable = () => {
  const navigate = useNavigate();

  return (
    <div>
      <div className="mb-4 flex justify-end">
        <Button text="Add Product" onClick={() => navigate("new")} type={ButtonStyle.TERTIARY} />
      </div>
      <ResourceTable<ExistingProduct>
        columns={PRODUCT_TABLE_COLUMNS}
        useQuery={useProducts}
        rowMapper={mapProductToRow}
        emptyMessage="No products found. Products will show up here."
      />
    </div>
  );
};

export default ProductsTable;
